import React from "react";
import playstore from "../images/playstore.png";
import appstore from "../images/appstore.png";
import phoneScreen from "../images/phoneScreen.png";
import applight_wave from "../images/applight-wave.svg";

export default function Header() {
  return (
    <section class="banner" id="home">
      <div class="banner-overlay">
        <div class="container">
          <div class="row">
            <div class="col-md-8 col-sm-12">
              <div class="banner-text">
                <h2 class="white">Crece con nosotros</h2>
                <h6 class="white">
                  Contactanos y podrás lograr un alcance óptimo de tu negocio o
                  servicio.
                </h6>
                <p class="banner-text white">
                  Confía en R&H para llevar tu negocio al siguiente nivel en el
                  mundo digital. Juntos, podemos crear una presencia en línea
                  sólida y atractiva que atraiga a nuevos clientes y fomente el
                  crecimiento y el éxito de tu empresa.
                </p>
                <ul>
                  <li>
                    <a>
                      <img
                        src={appstore}
                        class="wow fadeInUp"
                        data-wow-delay="0.4s"
                      />
                    </a>
                  </li>
                  <li>
                    <a>
                      <img
                        src={playstore}
                        class="wow fadeInUp"
                        data-wow-delay="0.7s"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="col-md-4 col-sm-12"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <img src={phoneScreen} class="img-fluid wow fadeInUp" />
            </div>
          </div>
        </div>
      </div>
      <span class="svg-wave">
        <img
          class="svg-hero"
          src={applight_wave}
          style={{ height: "50px", width: " 100%" }}
        />
      </span>
    </section>
  );
}
